import { render } from "./SectionOpenCloseBtn.vue?vue&type=template&id=5da4b820"
import script from "./SectionOpenCloseBtn.vue?vue&type=script&lang=js"
export * from "./SectionOpenCloseBtn.vue?vue&type=script&lang=js"

import "./SectionOpenCloseBtn.vue?vue&type=style&index=0&id=5da4b820&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__